import { Modal, Button, Form } from "react-bootstrap";
import { useForm, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  useGetSifrantStatusovProjekta,
  useGetStatusValidationFieldsForProject,
  useChangeProjectStatus,
} from "../../../services/ProjectDetails/statusProjektaAPI";
import sifrantSetSelectValueAndLabel from "../../utils/sifrantSetSelectValueAndLabel";
import FormSelect from "../../ui/FormSelect";
import ErrorMessage from "../../ui/ErrorMessage";
import { useEffect } from "react";

const StatusProjektaModal = ({ show, onHide, currentStatus }) => {
  const { id } = useParams();
  const { data: statusOptions, isLoading: sifrantIsLoading } =
    useGetSifrantStatusovProjekta();

  const setSifrantOptions = sifrantSetSelectValueAndLabel(statusOptions);

  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      statusID: null,
    },
  });

  const watchedStatusID = useWatch({ control, name: "statusID" });

  const { data: fieldValidationsForStatus, isLoading: isLoadingValidation } =
    useGetStatusValidationFieldsForProject(id, watchedStatusID);

  const {
    mutate: changeProjectStatus,
    isPending: isPendingChange,
    isError,
    error,
    reset: resetMutationError,
  } = useChangeProjectStatus(id, watchedStatusID);

  // Reset form values when currentStatus changes
  useEffect(() => {
    reset({
      statusID: currentStatus?.statusID || null,
    });
  }, [currentStatus, reset]);

  const onSubmit = () => {
    changeProjectStatus(undefined, {
      onSuccess: () => {
        onHide();
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <p>
            Trenutni status:{" "}
            <span className="text-success fw-bold">
              {currentStatus?.status}
            </span>
          </p>
          <hr className="form-section-divider" />
          {!sifrantIsLoading && (
            <FormSelect
              label="Izberi novi status projekta"
              name="statusID"
              control={control}
              options={setSifrantOptions}
            />
          )}
          {isLoadingValidation && watchedStatusID && (
            <p className="text-muted mt-3">Preverjanje pogojev...</p>
          )}
          {!isLoadingValidation &&
            fieldValidationsForStatus &&
            fieldValidationsForStatus.length === 0 && (
              <p className="text-success mt-3">
                Ni manjkajočih podatkov, izvedbo spremembe statusa potrdite s
                klikom na gumb "Potrdi spremembo statusa".
              </p>
            )}
          {!isLoadingValidation &&
            fieldValidationsForStatus &&
            fieldValidationsForStatus.length > 0 && (
              <div className="mt-3">
                <p className="fw-bold text-danger">
                  Manjkajoči podatki po posameznih zavihkih:
                </p>
                {fieldValidationsForStatus.map((item, index) => (
                  <div key={index} className="mb-2">
                    <span className="fw-semibold">{item.zavihek}</span>
                    <ul className="mb-1">
                      {item.polja.map((polje, i) => (
                        <li key={i}>{polje}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            variant="primary"
            disabled={
              !isDirty ||
              isPendingChange ||
              isLoadingValidation ||
              (fieldValidationsForStatus &&
                fieldValidationsForStatus.length > 0) ||
              watchedStatusID === currentStatus?.statusID
            }
          >
            {isPendingChange
              ? "Spreminjanje statusa..."
              : "Potrdi spremembo statusa"}
          </Button>
          <Button variant="secondary" onClick={onHide}>
            Prekliči
          </Button>
        </Modal.Footer>
        {isError && (
          <ErrorMessage message={error?.message || "Prišlo je do napake"} />
        )}
      </Form>
    </Modal>
  );
};

export default StatusProjektaModal;
